import { getFocalPointStyles } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { Hidden, LazyImage, Link } from "@insite/mobius/index";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { BannerCarouselList } from "@NA/Services/GetBannerCarousel";
import ADIColors from "@NA/Utils/ADIColors";
import React from "react";
import { css } from "styled-components";
import { bannerGaTag, bannerButtonGaTag, bannerButtonGaTagLYT } from "@NA/Utils/GtmUtility";
import Img from "@insite/mobius/Img";

interface OwnProps {
    slide: BannerCarouselList;
    extendedStyles?: ADIBannerStyles;
    onClick(url: string, isNewTab:boolean): void;
}

export interface ADIBannerStyles {
    slideContentWrapper?: InjectableCss;
    slideOverlayWrapper?: InjectableCss;
    logoImageWrapper?: InjectableCss;
    headingText?: TypographyPresentationProps;
    subheadingText?: TypographyPresentationProps;
    smallCopyText?: TypographyPresentationProps;
    headingMobileText?: TypographyPresentationProps;
    subheadingMobileText?: TypographyPresentationProps;
    slideButton?: ButtonPresentationProps;
    slideMobileButton?: ButtonPresentationProps;
    contentWarpper?: InjectableCss;
    imageWarpper?: InjectableCss;
    imageModileWarpper?: InjectableCss;
    contentMobileWarpper?: InjectableCss;
    bannerWithButton?: InjectableCss;
    bannerWithoutButton?: InjectableCss;
}

export const adiBannerStyles: ADIBannerStyles = {
    slideContentWrapper: {
        css: css`
            display: flex;
            flex: 0 0 100%;
            position: relative;
            color: ${ADIColors.white};
            background-repeat: no-repeat;
            height: 480px;
            @media all and (max-width: 1700px) {
                height: 400px;
            }
            @media all and (max-width: 1450px) {
                height: 342px;
            }
            width: 1600px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        height: auto;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    slideOverlayWrapper: {
        css: css`
            width: 100%;
        `,
    },
    slideButton: {
        css: css`
            margin: 0px;
            width: fit-content;
            padding: 9px 40px;
            position: relative;
            bottom: 0px;
            min-width: 160px;
            height: 60px;
            border-radius: 5px;
            text-transform: uppercase;
            box-shadow: inset 0 -4px 0 0 ${ADIColors.blue1};
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            padding: 20px 27px;
            background: ${getColor("primary")};
            white-space: nowrap;
            border: none;
            @media all and (max-width: 1450px) {
                min-width: 180px;
                height: 40px;
                padding: 9px 35px;
            }
        `,
    },
    slideMobileButton: {
        css: css`
            position: absolute;
            bottom: 0;
            min-height: 30px;
            height: 30px;
            padding: 5px 3px;
            min-width: 130px;
            text-transform: uppercase;
            line-height: 18px;
            box-shadow: inset 0 -4px 0 0 ${ADIColors.blue1};
            background: ${getColor("primary")};
            border: none;
            border-radius: 7px;
            margin-bottom: 10px;
            span {
                font-size: 12px !important;
            }
        `,
    },
    logoImageWrapper: {
        css: css`
            max-height: 40px;
            margin-bottom: 15px;
            max-width: 370px;
            height: 40px;
            img {
                height: 100% !important;
            }
        `,
    },
    headingText: {
        css: css`
            font-size: 46px;
            text-align: left;
            line-height: 40px;
            margin-bottom: 10px;
            font-weight: 300;
            @media all and (max-width: 1450px) {
                font-size: 34px;
                line-height: 34px;
            }
        `,
    },
    subheadingText: {
        css: css`
            font-size: 20px;
            font-weight: normal;
            margin-top: 2px;
            text-align: left;
            line-height: 20px;
            margin-bottom: 7px;
        `,
    },
    smallCopyText: {
        css: css`
            font-size: 14px;
            font-weight: normal;
            text-align: left;
            line-height: 15px;
            margin-bottom: 7px;
        `,
    },
    headingMobileText: {
        css: css`
            font-size: 34px;
            line-height: 36px;
            margin-bottom: 4px;
            color: ${ADIColors.darkBlue5};
        `,
    },
    subheadingMobileText: {
        css: css`
            font-size: 18px;
            font-weight: 400;
            height: 20px;
            margin-top: 2px;
            color: ${ADIColors.darkBlue5};
            height: auto;
        `,
    },
    contentWarpper: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            margin-left: 15px;
            height: 325px;
            padding-left: 130px;
            margin-top: 70px;
            margin-bottom: auto;
            @media all and (max-width: 1700px) {
                margin-top: auto;
            }
            @media all and (max-width: 1450px) {
                margin-top: auto;
                height: 270px;
                padding-left: 75px;
            }
            width: 50%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    contentMobileWarpper: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            margin-top: 10px;
            text-align: left;
            height: 100%;
            position: relative;
            padding: 0 15px 50px 15px;
        `,
    },
    bannerWithButton: {
        css: css`
            display: flex;
            flex-direction: column;
            height: 100%;
            justify-content: center;
            align-items: flex-start;
            margin: auto 0;
        `,
    },
    bannerWithoutButton: {
        css: css`
            display: flex;
            flex-direction: column;
            height: auto;
            justify-content: center;
            align-items: flex-start;
            margin: auto 0;
        `,
    },
    imageWarpper: {
        css: css`
            height: 480px;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 50%;
            img {
                max-height: 390px;
            }
            @media all and (max-width: 1700px) {
                height: 400px;
                img {
                    max-height: 100%;
                    max-width: 100%;
                }
            }
            @media all and (max-width: 1450px) {
                height: 342px;
                img {
                    max-height: 100%;
                    max-width: 100%;
                }
            }
        `,
    },
    imageModileWarpper: {},
};

const ADIBannerSlide = ({ slide, extendedStyles, onClick }: OwnProps) => {
    const styles = useMergeStyles("slideshow", adiBannerStyles, extendedStyles);

    const responsiveImageBehaviorStyles = "background-size: cover;";
    const backgroundStyles = `background-image: url(${slide.backgroundImage});`;
    const focalPointStyles = "background-position: 100% 100%;";
    const overlayPositioningStyles = "align-items: stretch;";

    const imageModileWarpperStyle = {
        css: css`
            background-image: url(${slide.centerBoxBackground});
            background-size: cover;
        `,
    };

    const slideWrapperStyles = {
        css: css`
            ${styles.slideContentWrapper?.css || ""}
            ${backgroundStyles}
        ${responsiveImageBehaviorStyles}
        ${focalPointStyles}
        ${overlayPositioningStyles}
        ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        background-image: unset;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    };
    const headingStyle = {
        css: css`
            ${styles.headingText?.css || ""}
            ${slide.cssClass === "dark" ? `color: ${ADIColors.white}` : `color: ${ADIColors.darkBlue5}`}
        `,
    };
    const subHeadingStyle = {
        css: css`
            ${styles.subheadingText?.css || ""}
            ${slide.cssClass === "dark" ? `color: ${ADIColors.white}` : `color: ${ADIColors.gray5}`}
        `,
    };
    const smallCopyStyle = {
        css: css`
            ${styles.smallCopyText?.css || ""}
            ${slide.cssClass === "dark" ? `color: ${ADIColors.white}` : `color: ${ADIColors.gray5}`}
        `,
    };
    const slideOverlayWrapperStyles = {
        css: css`
            ${styles.slideOverlayWrapper?.css || ""}
            display: flex;
            width: 100%;
            justify-content: space-between;
            max-width: 1440px;
            margin: 0 auto;
            cursor:pointer;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0 0 25px 0;
                        margin-top: 0;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    };

    const getGaPromoTag = (slide: BannerCarouselList) => {
        let tag = "";
        if (slide.isRewardEnrolledUser || slide.isRewardInvitedUser)
            tag = bannerButtonGaTagLYT(slide);
        else
            tag = bannerButtonGaTag(slide);
        return tag;
    }

    return (
        <StyledWrapper {...slideWrapperStyles}>
            <StyledWrapper {...slideOverlayWrapperStyles} onClick={() => onClick(slide.bannerLinkUrl, slide.isNewTab)} className="homepagebanner">
                {/* Desktop */}
                <Hidden
                    below="sm"
                    css={css`
                        display: flex;
                        flex-basis: 100%;
                        justify-content: space-between;
                    `}
                >
                    <StyledWrapper {...styles.contentWarpper} >
                        <StyledWrapper
                            {...(slide.bannerButtonText ? styles.bannerWithButton : styles.bannerWithoutButton)}
                        >
                            <StyledWrapper {...styles.logoImageWrapper} >
                                {slide.logoImageUrl !==
                                    "https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Promo/blank-logo.png" &&
                                    slide.bannerButtonText !== "" && <Img altText="Logo" loading="eager" src={slide.logoImageUrl} />}
                            </StyledWrapper>
                            {slide.headerLineOne && (
                                <Typography as="h2"
                                    {...headingStyle}
                                    dangerouslySetInnerHTML={{ __html: slide.headerLineOne }}
                                />
                            )}

                            {slide.headerLineTwo && (
                                <Typography as="h2"
                                    {...headingStyle}
                                    dangerouslySetInnerHTML={{ __html: slide.headerLineTwo }}
                                />
                            )}

                            {slide.copyTextOne && (
                                <Typography
                                    {...subHeadingStyle}
                                    dangerouslySetInnerHTML={{ __html: slide.copyTextOne }}
                                />
                            )}

                            {slide.copyTextTwo && (
                                <Typography
                                    {...subHeadingStyle}
                                    dangerouslySetInnerHTML={{ __html: slide.copyTextTwo }}
                                />
                            )}

                            {slide.copyTextThree && (
                                <Typography
                                    {...subHeadingStyle}
                                    dangerouslySetInnerHTML={{ __html: slide.copyTextThree }}
                                />
                            )}
                            {slide.smallCopyTextOne && (
                                <Typography {...smallCopyStyle}>{slide.smallCopyTextOne}</Typography>
                            )}
                            {slide.smallCopyTextTwo && (
                                <Link href={slide.callToAction} {...smallCopyStyle}>
                                    {slide.smallCopyTextTwo}
                                </Link>
                            )}
                            <StyledWrapper style={{ flex: 1 }} />
                            {slide.bannerButtonText && (
                                <Button data-ga-promo= {getGaPromoTag(slide)}
                                    {...styles.slideButton}
                                    variant="primary"
                                    onClick={() => onClick(slide.bannerLinkUrl, slide.isNewTab)}
                                >
                                    {slide.bannerButtonText}
                                </Button>
                            )}
                        </StyledWrapper>
                    </StyledWrapper>
                    <StyledWrapper {...styles.imageWarpper}>
                        <Img altText={slide.imageAlternativeText} loading="eager" src={slide.imageURL} />
                    </StyledWrapper>
                </Hidden>
                {/* mobile */}
                <Hidden
                    above="sm"
                    css={css`
                        display: flex;
                        flex-basis: 100%;
                        flex-direction: column;
                    `}
                >
                    <StyledWrapper {...imageModileWarpperStyle}>
                        <LazyImage altText={slide.imageAlternativeText} src={slide.imageURL} />
                    </StyledWrapper>
                    <StyledWrapper {...styles.contentMobileWarpper}>
                        {slide.logoImageUrl !==
                            "https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Promo/blank-logo.png" &&
                            slide.bannerButtonText !== "" && (
                                <StyledWrapper {...styles.logoImageWrapper}>
                                    <LazyImage src={slide.logoImageUrl} />
                                </StyledWrapper>
                            )}
                        {slide.headerLineOne && (
                            <Typography {...styles.headingMobileText} 
                            dangerouslySetInnerHTML={{ __html: slide.headerLineOne }}
                            />
                                
                        )}
                        {slide.headerLineTwo && (
                            <Typography {...styles.headingMobileText} 
                             dangerouslySetInnerHTML={{ __html: slide.headerLineTwo }}
                            />
                        )}

                        <Typography {...styles.subheadingMobileText}>
                            {slide.copyTextOne} {slide.copyTextTwo} {slide.copyTextThree}
                        </Typography>
                        <Button
                            {...styles.slideMobileButton}
                            variant="primary"
                            onClick={() => onClick(slide.bannerLinkUrl, slide.isNewTab)}
                        >
                            {slide.bannerButtonText}
                        </Button>
                    </StyledWrapper>
                </Hidden>
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default ADIBannerSlide;
